// useSecondsToTime.ts
import { useState, useEffect } from 'react';

const useSecondsToTime = (initialTotalSeconds: number) => {
  const [totalSeconds, setTotalSeconds] = useState<number>(initialTotalSeconds);
  const [time, setTime] = useState<string>('');

  useEffect(() => {
    const days = String(Math.floor(totalSeconds / (3600 * 24))).padStart(2, '0');
    const remainingSeconds = totalSeconds % (3600 * 24);
    const hours = String(Math.floor(remainingSeconds / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((remainingSeconds % 3600) / 60)).padStart(2, '0');
    const seconds = String(remainingSeconds % 60).padStart(2, '0');

    setTime(`${days}:${hours}:${minutes}:${seconds}`);
  }, [totalSeconds]);

  return { totalSeconds, time, setTotalSeconds };
};

export default useSecondsToTime;
